import { PATHS } from "rivals/shared/constants";
import { PEOPLE_FILTERS_TYPES, PeopleFiltersType } from "./types";

export const setDefaultFilters = (): PeopleFiltersType => ({
  [PEOPLE_FILTERS_TYPES.ATHLETIC_YEAR]: "",
  [PEOPLE_FILTERS_TYPES.ORIGIN_COLLEGE]: "",
  [PEOPLE_FILTERS_TYPES.EXIT_COLLEGE]: "",
  [PEOPLE_FILTERS_TYPES.TRANSFER_POSITION]: ""
});

export function setTransferTrackerPathVariables(
  year: number | string,
  sport: string
): string {
  return `${PATHS.TRANSFER_TRACKER.replace("[year]", year.toString()).replace(
    "[sport]",
    sport
  )}`;
}
